import styled, { css } from 'styled-components';
import { Card, Description, Title } from './core.styles';

export const InverseCard = styled(Card)`
  ${({ theme }) => css`
    background: ${theme.v3.colors.brand.snappyBlue[98]};
  `}
`;

export const InverseTitle = styled(Title)`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[20]};
  `}
`;

export const InverseDescription = styled(Description)`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[20]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    text-shadow: 0 2px 10px rgba(0, 18, 37, 0.15);

    strong {
      font-weight: ${theme.v3.font.weights.bold};
    }
  `}
`;
